import IconSearch from "./icon-search";

export default IconSearch;
